module.exports = __webpack_public_path__ + "static/media/wallet.7339c4a3.svg";